// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2oW47","title":"footer_title__piRrt","description":"footer_description__NPmPK","footerlink":"footer_footerlink__aH3y3"};